import { render, staticRenderFns } from "./ArchiveEventsList.vue?vue&type=template&id=94ebbffe"
import script from "./ArchiveEventsList.vue?vue&type=script&lang=js"
export * from "./ArchiveEventsList.vue?vue&type=script&lang=js"
import style0 from "./ArchiveEventsList.vue?vue&type=style&index=0&id=94ebbffe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports